// "Save as" — give a number your own name for them. One prompt for every
// place that offers it: Friends ⋯ Rename, accepting a request, the thread's
// name strip, a page's ⋯, a group's member list.
//
// Prefilled with the name you already gave them, else the name they chose
// (their handle), so accepting it as-is is one tap. Only this phone sees it.

import { alertController } from '@ionic/vue';
import { friendByNumber, friendName, renameFriend, groups } from '../store.js';
import { formatNumber } from '../pm/format.js';

function handleOf(number) {
  const f = friendByNumber(number);
  if (f?.handle) return f.handle;
  for (const g of groups.value) {
    const m = g.members.find((x) => x.number === number);
    if (m?.handle) return m.handle;
  }
  return '';
}

/**
 * Ask for a name and save it. Resolves true when something was saved.
 * @param {string} number  10 digits
 * @param {{ header?: string, message?: string }} [opts]
 */
export async function promptName(number, { header, message } = {}) {
  const n = String(number ?? '');
  const f = friendByNumber(n);
  const handle = handleOf(n);
  const a = await alertController.create({
    header: header ?? `Save ${friendName(n)} as`,
    message: message ?? `${formatNumber(n)}${handle ? ` · they call themselves ${handle}` : ''}. Only you see this name.`,
    inputs: [{
      name: 'name',
      type: 'text',
      value: f?.name || handle || '',
      placeholder: handle || formatNumber(n),
      attributes: { maxlength: 24, 'aria-label': 'Name', autocapitalize: 'words' },
    }],
    buttons: [{ text: 'Cancel', role: 'cancel' }, { text: 'Save', role: 'confirm' }],
  });
  await a.present();
  const { role, data } = await a.onDidDismiss();
  if (role !== 'confirm') return false;
  const typed = String(data?.values?.name ?? '').trim();
  // Saving their own handle back is the same as no local name: it keeps
  // following them if they change it.
  const name = handle && typed.toUpperCase() === handle.toUpperCase() ? '' : typed;
  return renameFriend(n, name).ok;
}
